import { render } from "./LandingpageView.vue?vue&type=template&id=030d314e&scoped=true&ts=true"
import script from "./LandingpageView.vue?vue&type=script&lang=ts"
export * from "./LandingpageView.vue?vue&type=script&lang=ts"

import "./LandingpageView.vue?vue&type=style&index=0&id=030d314e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030d314e"]])

export default __exports__